import { isRecord } from '@/shared/utils/isRecord';

export function getErrorStatus(error: unknown): number | undefined {
  if (!isRecord(error)) return undefined;
  const { status } = error;
  return typeof status === 'number' ? status : undefined;
}
